import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Footer from "@/components/site/Footer";
import PromoBanner from "@/components/site/PromoBanner";
import SEO from "@/components/seo/SEO";

const LegalLayout = ({ kicker, title, updated, children, path }) => {
  return (
    <main className="min-h-screen bg-[#F7F7F4]">
      <SEO title={kicker} description={`${kicker} for Vaymilo — last updated ${updated}.`} path={path} />
      <PromoBanner />
      {/* Compact header */}
      <header className="sticky top-0 z-30 bg-[#F7F7F4] border-b border-[#E7E7E2]">
        <div className="max-w-4xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-logo-home"
            className="font-sora text-[22px] md:text-[24px] font-extrabold tracking-tight text-[#111111] leading-none"
          >
            Vaymilo<span className="text-[#2563EB]">.</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1 font-manrope text-sm text-[#111111]/70 hover:text-[#111111] transition-colors"
          >
            Back to site
            <ArrowUpRight size={14} />
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-24 md:pb-32">
        <div className="overline">— {kicker}</div>
        <h1 className="mt-5 font-sora text-[40px] sm:text-[52px] lg:text-[60px] font-extrabold tracking-tight leading-[1.05] text-[#111111]">
          {title}
        </h1>
        <p className="mt-5 font-mono text-[11px] tracking-[0.2em] uppercase text-[#111111]/45">
          Last updated · {updated}
        </p>

        <div className="mt-12 prose-vaymilo">{children}</div>

        <div className="mt-20 pt-8 border-t border-[#E7E7E2] flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="font-manrope text-[14px] text-[#111111]/60">
            Questions about this policy?
          </p>
          <a
            href="mailto:hello@vaymilo.com"
            className="font-manrope text-[14px] font-medium text-[#111111] hover:text-[#2563EB] transition-colors border-b border-[#E7E7E2] hover:border-[#2563EB] pb-0.5 self-start"
          >
            hello@vaymilo.com
          </a>
        </div>
      </article>

      <Footer />
    </main>
  );
};

export default LegalLayout;
